// extracted by mini-css-extract-plugin
module.exports = {"event":"index_event_3GV86","header":"index_header_32hLA","primarySpan":"index_primarySpan_2CPYz","fileWrap":"index_fileWrap_18sb6","icon":"index_icon_8AshR"};